export default "__VITE_ASSET__CAhvWRuk__"